import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'

interface ActionButtonInterface {
  isActive: boolean
}

export const styles = {
  approvalActionContainer: {
    maxHeight: '70vh',
    overflow: 'auto',
    bg: '#0000001f' as ColorOptions,
    p: 'MEDIUM',
  } as BoxProps,
  approveButton: {
    bg: 'BG_PRIMARY_SUCCESS',
    underlayColor: 'AVAILABLE_GREEN',
    p: 'MEDIUM',
    justify: 'center',
    align: 'center',
    borderRadius: 4,
  } as BoxProps,
  rejectButton: {
    bg: 'ERROR',
    underlayColor: 'RED',
    p: 'MEDIUM',
    justify: 'center',
    align: 'center',
    borderRadius: 4,
  } as BoxProps,
  cardInnerText: {
    fontWeight: 'BOLD',
    fontSize: 14,
    color: 'DARK_GREY',
    fontFamily: 'jiotype-medium',
  } as TextProps,
  roundedAction: ({ isActive }: ActionButtonInterface) =>
    ({
      p: 10,
      bg: isActive ? 'GREEN' : 'RED',
      borderRadius: 6,
      underlayColor: isActive ? 'BRAND_PRIMARY_GREEN' : 'ERROR',
    } as BoxProps),
  cardTitleText: {
    fontWeight: '700',
    color: 'BLACK',
  } as TextProps,
  dashedContainer: {
    bg: 'WHITE',
    borderRadius: 6,
    w: '100%',
    justify: 'center',
    align: 'center',
    borderWidth: 1,
    borderStyle: 'dashed',
    p: 'MEDIUM',
    borderColor: 'GREY_1_SEPARATOR',
  } as BoxProps,
  approvalWrapper: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    ph: 'BIG',
    pb: 20,
  } as BoxProps,
  individualItemWrapper: {
    f: 1,
    p: 'BIG',
  } as BoxProps,
  listItem: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    w: '100%',
  } as BoxProps,
}
